function resolveBaseUrl(): string {
  const envUrl = process.env.SERVER_URL_DEV || '';
  if (process.env.NODE_ENV === 'development') {
    try {
      const parsed = new URL(envUrl);
      if (parsed.hostname === 'localhost' || parsed.hostname === '10.0.2.2') {
        parsed.hostname = window.location.hostname;
        return parsed.toString();
      }
    } catch {
      // non-URL or missing — fall through
    }
  }
  return envUrl;
}

export function getApiUrl() {
  return `${resolveBaseUrl()}api/v1/`;
}
export function getServerUrl() {
  return resolveBaseUrl();
}
